import { TMS_THEME } from "../theming/theming";
export var calculateBorderRadius = function (borderRadius) {
    switch (borderRadius) {
        case "zero":
            return 0;
        case "default":
            return TMS_THEME.root.borderRadius;
        default:
            return {};
    }
};
